export const getParams = function getParams(key, obj, params) {
  try {
    // if (typeof obj[key] !== 'string') {
    // }
    const { type = '', value, func } = obj[key] || {};
    if (type === 'constant') {
      return value;
    } else if (type === 'variable') {
      let finalFunc = null;
      if (process.env && process.env.MIX_ENV === 'mini') {
        finalFunc = () => func;
      } else {
        // eslint-disable-next-line no-new-func
        finalFunc = new Function('', 'return ' + func);
      }
      const f = finalFunc();
      const { traceData, type } = params;
      return (typeof f === 'function' && finalFunc()(traceData, type)) || '';
    }
  } catch (e) {
    console.log('解析config出错', e);
  }
};
